import moment from 'moment';
import { createContext, useContext } from 'react';
import { tCancelSubscriptionContextValue } from './CancelSubscription.types';

const CANCEL_SUBSCRIPTION_CONTEXT_INITIAL_STATE: tCancelSubscriptionContextValue =
  {
    // State
    showForm: false,
    showOfferModal: false,
    showConfirmationModal: false,
    showSchedulingModal: false,
    retentionSessionCta: { kind: 'none' },
    cancellationReason: null,
    retentionOffer: null,
    appliedRetentionOffer: null,
    appliedPlanPauseMonths: null,
    retentionFlowError: null,
    leadsByFunnel: [],
    isLoadingLeads: false,
    sentMessagesCount: 0,
    hasZeroLeads: false,
    activeFunnelsCount: 0,
    totalLeadsCount: 0,
    userNames: [],
    remainingUsersCount: 0,
    isLoadingReasonSelection: false,
    isLoadingOfferAcceptance: false,
    isLoadingFinalization: false,
    planNotSuitableInvoicePreview: null,

    // Handlers
    setShowForm: () => {},
    handleBackToReasons: () => {},
    handleKeepSubscription: () => {},
    handleContinue: () => {},
    handleClose: () => {},
    handleSelectReason: async () => {},
    handleAcceptOffer: async () => {},
    handleRetryOffer: () => {},
    handleContinueToCancellation: async () => {},
    handleCloseConfirmation: async () => {},
    handleScheduleSession: () => {},
    handleScheduleConsultation: () => {},
    handleFinalizeSubscription: async () => {},

    calculateDates: () => ({
      nextChargeDate: moment(),
      formatDate: () => '',
    }),
  };

export const CancelSubscriptionContext = createContext(
  CANCEL_SUBSCRIPTION_CONTEXT_INITIAL_STATE,
);

export function useCancelSubscriptionContext(): tCancelSubscriptionContextValue {
  return useContext(CancelSubscriptionContext);
}
